import React, { Component } from 'react';
import Backdrop from '../Backdrop/Backdrop';
import Button from '../Button/Button';
import classes from './Modal.module.css';
import { CSSTransition } from 'react-transition-group'

class Modal extends Component {
    state = {
        show: this.props.showModal
    }

    noHandler = () => {
        this.setState({ show: !this.state.show }, () => {
            console.log("[noHandler] " + this.state.show)
            this.props.modalVisibilityHandler()
        })
    }

    yesHandler = () => {
        this.setState({ show: !this.state.show }, () => {
            this.props.notify(false, "Image Discarded.")
            this.props.modalVisibilityHandler()
            this.props.displayContainerHandler()
        })
    }

    render() {
        let modalComponent = (
            <CSSTransition
                in={!this.state.showScreenshotContainer}
                appear={true}
                timeout={300}
                classNames="fade"
            >
                <div>
                    <div className={classes.modal}>
                        <div>
                            <h1>Do you want to close without submitting?</h1>
                            <hr />
                            <p>Screenshot and Edits will be discarded</p>
                        </div>
                        <div className={classes.modalButtons}>
                            <Button type={"button-success"} buttonName="Yes" style={{ width: "10%", marginRight: "1%" }} onClick={() => this.yesHandler} />
                            <Button buttonName="No" style={{ width: "10%", marginLeft: "1%" }} onClick={() => this.noHandler} />
                        </div>
                    </div>

                    <Backdrop />
                </div>
            </CSSTransition>
        )
        return (
            <div>
                {this.state.show ? modalComponent : null}
            </div>
        )
    }
}

export default Modal